import { Routes, Route } from "react-router-dom";
import { QuickTable, QuickTableFilterTabs } from "../../../components";
import { TransferReceiptModal } from "../BatchTransfersList/TransferReceiptModal";
import {
  ISingleTransferNoBatchListViewProps,
  TRANSFERS_LIST_TABLE_NAME,
} from "./SingleTransferNoBatchList";
import { singleTransferDisplayFormatter } from "./singleTransferDisplayFormatter";

export const View = (props: ISingleTransferNoBatchListViewProps) => {
  return (
    <>
      <QuickTable
        id={TRANSFERS_LIST_TABLE_NAME}
        prefixFiltersWithId
        data={props.transfersInBatch}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
            filterPrefix={TRANSFERS_LIST_TABLE_NAME}
          />
        }
        displayFormatter={singleTransferDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="New Transfer"
        openDetailsModal={props.openSingleTransferDetailsReceiptModal}
        detailsModalKeySelector={(trsf) => trsf.id}
        rowTitleSelector={(trsf) => trsf.description ?? null}
        disableClickOnColumns={["account_name", "account_number", "session_id"]}
      />

      <Routes>
        <Route path=":id/receipt" element={<TransferReceiptModal />} />
      </Routes>
    </>
  );
};
